















import { MallProductListStore } from "@/store/namespace";
import { inMobileApp } from "@/utils/mobile/MobileApp";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class MallShoppingCartIcon extends Vue {
  @MallProductListStore.State cartNumber: number;
  @MallProductListStore.Action getCartSkuAmountAction: Function;

  mounted() {
    this.getCartSkuAmountAction();
  }

  // 去购物车
  toMallCart() {
    // 在app中，跳转购物车的tabBar
    if (inMobileApp()) {
      window.nativeApp?.toWinCart();
    }
    // 其他地方直接路由跳转。
    else {
      // 购物车新增积分抵扣功能，改动较大，h5不做改动（20250527）
      this.$router.push({ name: "MallShoppingCart" });
    }
  }
}
